import React, {useEffect, useState} from "react";
import {Navigate} from '../../../.vite/deps/react-router-dom.js';
import {mrbgStore} from './mrbgRedux/index.js'
import mrbgS2S from '../../mrbgLib/mrbgS2S.js'
import MrbgLoader from './MrbgLoader.jsx'
import headerStyle from './../../static/css/MP_header.module.css';
import sesDetStyle from './../../static/css/MP_sessionDetail.module.css';
import { mrbgTools } from '../../mrbgLib/mrbgTools.js'

function MrbgSessionDetail(){

  const
    [tokenInfo, setTokenInfo   ] = useState(mrbgStore.getState().__TK?.EP),
    [failedMsg, setFailedMsg   ] = useState(undefined),
    [sessionInfo,setSessionInfo] = useState(undefined),
    id = decodeURI(window.location.pathname).replace('/panel/','');

  document.documentElement.setAttribute( 'lang', 'fa' );
  document.documentElement.querySelector('title').innerText = mrbgStore.getState().enTitle.replace(/\b\w/g, char => char.toUpperCase());

  useEffect(() => {
    const unsubscribe = mrbgStore.subscribe(() => {
      setTokenInfo( mrbgStore.getState().__TK?.EP );
    });
    return () => unsubscribe();
  }, []);


  if( tokenInfo?.id===undefined ){
    if( failedMsg===undefined ){
      var MD = new FormData();
      MD.append('id',id);
      mrbgS2S(null, MD, 'sesDet', 'apo')
        .then (x=>{
          typeof x === 'object'?
            setSessionInfo(x):
            setFailedMsg(x)
        })
        .catch( y=>setFailedMsg(y) );
    }

    if( failedMsg )
      return <div dangerouslySetInnerHTML={{ __html: failedMsg }} />
    else
      return <MrbgLoader />
  }
  else if( tokenInfo.id && tokenInfo.PR ){
    return(
      <main id={sesDetStyle.main}>
        <header id={headerStyle.MP_header}>
          <ul>
            <li id={headerStyle.MP_mehraz}>
              <a href="#" className={headerStyle.organizationalGradiant}>Developed By Mehraz Tech</a>
              <svg id={headerStyle.MP_mehrazLogo} viewBox="0 0 100 50" alt="مهرازتک - بابک گلبهاران">
                <path id={headerStyle.MP_MLF1} d="M80,17 l0,14.75 c0,3 -2.5,3 -3,3 l-3.5,0 c-3,0 -3,-3 -3,-3 l0,-0.75 l-11.25,15.75 c-1.5,2 -3,2.75 -4,3 l-4.75,0 c-3,0 -3,-3 -3,-3 l0,-16 l-11,15.75 c-1.5,2 -3,2.75 -4,3 l-7.75,0 c-0.4,0 -1.1,-0.6 -.8,-1.4 l22,-31.5 c1,-1.75 3,-3 4,-3 l4.25,0 c2,0 3,1.5 3,3 l0,16.25 l11.25,-16.25 c1,-1.75 3,-3 4,-3 l4.5,0 c2,0 3,1.5 3.1,3.4z"></path>
                <path id={headerStyle.MP_MLF2} d="M45.75,4.25 l0,7.75 l-8.25,11.75 c-0.25,.5 -0.75,.5 -1.25,-0.25 l0,-19.25 c0,-2.5 2.5,-3 3,-3 l3.5,0 c2,0 3,1.5 3,3 z"></path>
                <path id={headerStyle.MP_MLF3} d="M34.25,17 l0,11 l-8.5,12 c-0.25,.5 -0.75,.5 -1.25,0 l0,-9 l-11.25,15.75 c-1.5,2 -3,2.75 -4,3 l-7.5,0 c-0.4,0 -1.1,-0.6 -.85,-1.4 l22,-31.75 c1,-2 3,-3 4,-3 l4.25,0 c2,0 3,1.5 3.1,3.1z"></path>
                <path id={headerStyle.MP_MLF4} d="M34,4.5 l0,3.5 c0,3 -2.5,3 -3,3 l-3.5,0 c-3,0 -3,-3 -3,-3 l0,-3.5 c0,-2.5 2.5,-3 3,-3 l3.5,0 c2,0 3,1.5 3,3"></path>
                <path id={headerStyle.MP_MLE} d="M65,42 h6 v1.6 h-4.4 v1.6 h4.4 v1.6 h-4.4 v1.6 h4.4 v1.6 h-6 v-8.32z M72.15,42 h1.6 v3.2 h1.6 v-3.2 h1.6 v8 h-1.6 v-3.2 h-1.6 v3.2 h-1.6 v-8z M78.2,42 h2.9 c4.13,0.1 4.13,4.7 0,4.8 l2.9,1.84 l-0.844,1.36 l-5.136,-3.2 v-1.6 h2.9 c2.53,0 2.53,-1.6 0,-1.6 h-2.9 v-1.6z M84.5,50 l4.4,-8 h1.6 v8 h-3.4 l.88,-1.3 h1.1 v-4.2 l-3.1,5.55 h-1.74z M91.6,44 v-2 h6 v2 l-4.3,4.5 h2.7 v-.6 h1.6 v2 h-6 v-2 l4.3,-4.4 h-2.8 v.6 h-1.8z"></path>
              </svg>
              <div>
                <a href="tel:09384439494" className={headerStyle.organizationalGradiant}>
                  <i className={`fa-regular fa-mobile ${headerStyle.organizationalGradiant}`}></i>
                  <bdi>0938 443 9494</bdi>
                </a>
                <a href="tel:09384439494" className={headerStyle.organizationalGradiant}>
                  <i className={`fa-regular fa-mobile ${headerStyle.organizationalGradiant}`}></i>
                  <bdi>0917 500 9694</bdi>
                </a>
              </div>
            </li>
          </ul>
        </header>
        {
          typeof sessionInfo==='object' && Object.keys(sessionInfo).length?
            <>
              {tokenInfo.empType!=='اپراتور'? <ClientDetail  {...{info:sessionInfo.client}}/>: ''}
              <ApoDetail {...{info:sessionInfo.apo,tokenInfo}} />
              <ApoSesDetail {...{info:sessionInfo.apoSes}} />
              <ApoAreaTbl {...{info:sessionInfo.apoAre}}/>
              <BillDetail {...{info:sessionInfo.bills}}/>
              <BillPaymentsDetail {...{info:sessionInfo.bilPayment}}/>
            </>:
            <div>{typeof sessionInfo}</div>
        }
      </main>
    )
  }
  else{
    return(
      <>
        <Navigate replace to={`/login`}/>
      </>
    );
  }
}
function ClientDetail({info}){
  return(
    <section className={sesDetStyle.section}>
      <h2>اطلاعات مشتری</h2>
      <ul className={sesDetStyle.sectionList}>
        <li>
          <span>نام مشتری:</span>
          <span>{info.fullName}</span>
        </li>
        <li>
          <span>نام پدر:</span>
          <span>{info.fatherName}</span>
        </li>
        <li>
          <span>موبایل:</span>
          <span>
            <a href={`tel:${info.phone}`}>{info.phone}</a>
          </span>
        </li>
        <li>
          <span>کذ ملی:</span>
          <span>{info.nationalCode}</span>
        </li>
        <li>
          <span>تولد:</span>
          <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(info.birthday,'date')}</span>
        </li>
        <li>
          <span>جنسیت:</span>
          <span>{info.gender}</span>
        </li>
        <li>
          <span>شغل:</span>
          <span>{info.job}</span>
        </li>
        <li>
          <span>آدرس:</span>
          <span>{info.address}</span>
        </li>
        <li>
          <span>ایجاد شده با:</span>
          <span>{info.createdBy}</span>
        </li>
        <li>
          <span>زمان ایجاد:</span>
          <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(info.createdAt)}</span>
        </li>
        <li>
          <span>ویرایش شده با:</span>
          <span>{info.updatedBy}</span>
        </li>
        <li>
          <span>زمان آخرین ویرایش:</span>
          <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(info.updatedAt)}</span>
        </li>
      </ul>
    </section>
  )
}
function ApoDetail({info,tokenInfo}){
  return(
    <section className={sesDetStyle.section}>
      <h2>اطلاعات نوبت</h2>
      <ul className={sesDetStyle.sectionList}>
        <li>
          <span>کد نوبت:</span>
          <span>{tokenInfo.empType==='اپراتور'? '':info.code}</span>
        </li>
        <li>
          <span>نوع رزرو:</span>
          <span>{info.bookingMethod}</span>
        </li>
        <li>
          <span>ایجاد شده با:</span>
          <span>{info.createdBy}</span>
        </li>
        <li>
          <span>زمان ایجاد:</span>
          <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(info.createdAt)}</span>
        </li>
        <li>
          <span>ویرایش شده با:</span>
          <span>{info.updatedBy}</span>
        </li>
        <li>
          <span>زمان آخرین ویرایش:</span>
          <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(info.updatedAt)}</span>
        </li>
      </ul>
    </section>
  )
}
function ApoSesDetail({info}){

  return(
    <section className={sesDetStyle.section}>
      <h2>اطلاعات جلسات</h2>
      {
        info.map((row,k)=>{
          return(
            <div className={sesDetStyle.partSec} key={k}>
              <h3>جلسه {row.num}</h3>
              <ul className={sesDetStyle.sectionList}>
                <li>
                  <span>شیفت:</span>
                  <span>{row.shiftName}</span>
                </li>
                <li>
                  <span>دستگاه:</span>
                  <span>{row.devName}</span>
                </li>
                <li>
                  <span>عجله دارم:</span>
                  <i className={`fa-regular ${row.force? 'fa-check': 'fa-close'} ${row.force? sesDetStyle.checkIcon: sesDetStyle.closeIcon}`}></i>
                </li>
                <li>
                  <span>زمان جلسه:</span>
                  <span className={sesDetStyle.ltr}>{`${mrbgTools.Calendar.m2j(row.beginDateTime,'date')} ${row.serviceTime}`}</span>
                </li>
                <li>
                  <span>زمان یادآوری:</span>
                  <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(row.remindDateTime,'date')}</span>
                </li>
                <li>
                  <span>وضعیت:</span>
                  <span>{row.bookingStatus}</span>
                </li>
                <li>
                  <span>اکتیو شده با:</span>
                  <span>{row.activatedBy}</span>
                </li>
                <li>
                  <span>زمان اکتیو شدن:</span>
                  <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(row.activatedAt)}</span>
                </li>
                <li>
                  <span>بهای کل:</span>
                  <span className={sesDetStyle.price}>{row.totalAmount.toPrice()}</span>
                </li>
                <li>
                  <span>تخفیف:</span>
                  <span className={sesDetStyle.price}>{row.discountAmount.toPrice()}</span>
                </li>
                <li>
                  <span>کسورات:</span>
                  <span className={sesDetStyle.price}>{row.deduction.toPrice()}</span>
                </li>
                <li>
                  <span>بهای مواد مصرفی:</span>
                  <span className={sesDetStyle.price}>{row.entitiesAmount.toPrice()}</span>
                </li>
                <li>
                  <span>بهای نهایی:</span>
                  <span className={sesDetStyle.price}>{row.finalAmount.toPrice()}</span>
                </li>
                <li>
                  <span>مبلغ پرداخت شده:</span>
                  <span className={sesDetStyle.price}>{row.totalAmountPaid.toPrice()}</span>
                </li>
                <li>
                  <span>تخفیف استفاده شده:</span>
                  <span>{row.discountTitle}</span>
                </li>
                <li>
                  <span>تعداد شات:</span>
                  <span className={sesDetStyle.price}>{row.shutCount.toPrice()}</span>
                </li>
                <li>
                  <span>زمان پایان یافتن:</span>
                  <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(row.completedAt)}</span>
                </li>
                <li>
                  <span>ایجاد شده با:</span>
                  <span>{row.createdBy}</span>
                </li>
                <li>
                  <span>زمان ایجاد:</span>
                  <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(row.createdAt)}</span>
                </li>
                <li>
                  <span>ویرایش شده با:</span>
                  <span>{row.updatedBy}</span>
                </li>
                <li>
                  <span>زمان آخرین ویرایش:</span>
                  <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(row.updatedAt)}</span>
                </li>
                <li>
                  <span>درج پایان با:</span>
                  <span>{row.completedBy}</span>
                </li>
                <li className={sesDetStyle.wideItem}>
                  <span>نواحی انتخاب شده:</span>
                  <span>{row.apoAreJson}</span>
                </li>
                <li className={sesDetStyle.wideItem}>
                  <span>مواد مصرفی:</span>
                  <span>{row.entities}</span>
                </li>
                <li className={sesDetStyle.wideItem}>
                  <span>توضیحات: (کیس های بدون نوبت)</span>
                  {
                    row.missedFollowDate?
                      <span>{`${mrbgTools.Calendar.m2j(row.missedFollowDate)} ${row.missedFollowNote || '...'}`}</span>:
                      <span></span>
                  }
                </li>
                <li className={sesDetStyle.wideItem}>
                  <span>توضیحات منشی:</span>
                  <span>{row.secretaryNote}</span>
                </li>
                <li className={sesDetStyle.wideItem}>
                  <span>توضیحات اپراتور</span>
                  <span>{row.operatorNote}</span>
                </li>
              </ul>
            </div>
          )
        })
      }
    </section>
  )
}
function ApoAreaTbl({info}){

  return(
      <section className={sesDetStyle.section}>
        <h2>اطلاعات نواحی</h2>
        {
          info.map((sessionInfo,k)=>{
            return(
              <div className={sesDetStyle.partSec} key={k}>
                <h3>نواحی جلسات {sessionInfo[0].num}</h3>
                <div className={sesDetStyle.tableFrame}>
                  <table className={sesDetStyle.mrbgTable}>
                    <thead>
                      <tr>
                        <th className={sesDetStyle.think}>ردیف</th>
                        <th>نام ناحیه</th>
                        <th>اپراتور</th>
                        <th className={sesDetStyle.think}>انرژی</th>
                        <th className={sesDetStyle.think}>اسکین تایپ</th>
                        <th className={sesDetStyle.think}>طول موج</th>
                        <th className={sesDetStyle.think}>کنسل</th>
                        <th className={sesDetStyle.think}>موکول به آینده</th>
                        <th>تسویه ی نوبت</th>
                        <th>تسویه در نوبت</th>
                        <th>ایجاد شده با</th>
                        <th>زمان ایجاد</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        sessionInfo.map((row,k2)=>{
                          return(
                            <tr key={k2}>
                              <td className={sesDetStyle.think}>{k2+1}</td>
                              <td>{row.areName}</td>
                              <td>{row.operator}</td>
                              <td className={sesDetStyle.think}>{row.energy}</td>
                              <td className={sesDetStyle.think}>{row.skinType}</td>
                              <td className={sesDetStyle.think}>{row.waveLength}</td>
                              <td className={sesDetStyle.think}>{row.canceled? <i className={`fa-solid fa-check ${sesDetStyle['fa-check']}`}></i>: '' }</td>
                              <td className={sesDetStyle.think}>{row.postponed? <i className={`fa-solid fa-check ${sesDetStyle['fa-check']}`}></i>: '' }</td>
                              <td>{row.clearedFor}</td>
                              <td>{row.clearedIn}</td>
                              <td>{row.createdBy}</td>
                              <td>{mrbgTools.Calendar.m2j(row.createdAt)}</td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            )
          })
        }
      </section>
    )
}
function BillDetail({info}){

  return(
    <section className={sesDetStyle.section}>
      <h2>اطلاعات صورت حساب</h2>
      {
        info.map((row,k)=>{
          return(
            <div className={sesDetStyle.partSec} key={k}>
              <h3>صورت حساب {row.title}</h3>
              <ul className={sesDetStyle.sectionList}>
                <li className={sesDetStyle.wideItem}>
                  <span>کد صورت حساب:</span>
                  <span>{row.code}</span>
                </li>
                <li>
                  <span>نوع:</span>
                  <span>{row.bilGrpName}</span>
                </li>
                <li>
                  <span>بها کل:</span>
                  <span className={sesDetStyle.price}>{row.totalAmount.toPrice()}</span>
                </li>
                <li>
                  <span>تخفیف:</span>
                  <span className={sesDetStyle.price}>{row.discount.toPrice()}</span>
                </li>
                <li>
                  <span>تعدیل:</span>
                  <span className={sesDetStyle.price}>{row.manualAdjustment.toPrice()}</span>
                </li>
                <li>
                  <span>بها نهایی:</span>
                  <span className={sesDetStyle.price}>{row.finalAmount.toPrice()}</span>
                </li>
                <li>
                  <span>کسورات:</span>
                  <span className={sesDetStyle.price}>{row.deduction.toPrice()}</span>
                </li>
                <li>
                  <span>پرداخت شده:</span>
                  <span className={sesDetStyle.price}>{row.paidAmount.toPrice()}</span>
                </li>
                <li>
                  <span>زمان پایان یافتن:</span>
                  <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(row.completedAt)}</span>
                </li>
                <li>
                  <span>ایجاد شده با:</span>
                  <span>{row.createdBy}</span>
                </li>
                <li>
                  <span>زمان ایجاد:</span>
                  <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(row.createdAt)}</span>
                </li>
                <li>
                  <span>ویرایش شده با:</span>
                  <span>{row.updatedBy}</span>
                </li>
                {
                  row.revoked?
                    <>
                      <li className={sesDetStyle.redColor}>
                        <span>ابطال شده با:</span>
                        <span>{row.revokedBy}</span>
                      </li>
                      <li className={sesDetStyle.redColor}>
                        <span>زمان ابطال:</span>
                        <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(row.revokedAt)}</span>
                      </li>
                    </>:
                    ''
                }
              </ul>
            </div>
          )
        })
      }
    </section>
  )
}
function BillPaymentsDetail({info}){

  return(
    <section className={sesDetStyle.section}>
      <h2>اطلاعات پرداخت صورت حساب</h2>
      {
        info.map((row,k)=>{
          return(
            <div className={sesDetStyle.partSec} key={k}>
              <h3>پرداخت صورت حساب {row.bilCode}</h3>
              <ul className={sesDetStyle.sectionList}>
                <li className={sesDetStyle.wideItem}>
                  <span>حساب/صندوق:</span>
                  <span>{row.funName}</span>
                </li>
                <li>
                  <span>نوع پرداخت:</span>
                  <span>{row.paidType}</span>
                </li>
                <li>
                  <span>مبلغ:</span>
                  <span className={sesDetStyle.price}>{row.amount?.toPrice()}</span>
                </li>
                <li>
                  <span>زمان پرداخت:</span>
                  <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(row.paidDateTime)}</span>
                </li>
                <li>
                  <span>زمان ایجاد:</span>
                  <span className={sesDetStyle.ltr}>{mrbgTools.Calendar.m2j(row.createdAt)}</span>
                </li>
                <li>
                  <span>ویرایش شده با:</span>
                  <span>{row.updatedBy}</span>
                </li>
              </ul>
            </div>
          )
        })
      }
    </section>
  )
}
export default MrbgSessionDetail;